/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Finisher } from "./modelFinisher";

class ControllerFinisher extends ControllerModel {
    constructor() {
        super("ControllerFinisher");

        this.setNewNode = (callback) => {
            let finisher = new Finisher();
            finisher.decorate(callback);

            this.addNode(finisher);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let finisher = new Finisher();
            finisher.copyFrom(node);
            finisher.decorate(callback);
            this.addNode(finisher)
        }

        this.getProperties = async (node) => {
            let n = new Finisher();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Finisher();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerFinisher };